const translations = {
  fr: {
    _label: 'Français',
    _flag: '🇫🇷',
    clickToChangeProject: 'Cliquez sur le logo pour changer',
    chooseProject: 'Choisir un projet :',
    loading: 'Chargement...',
    noProject: 'Aucun projet',
    active: 'actif',
    versionHistory: 'Historique des versions',
    downloadLogs: 'Télécharger logs debug',
    serverHealth: 'État du serveur',
    logout: 'Déconnexion',
    lightMode: 'Mode Jour',
    darkMode: 'Mode Nuit',
    all: 'TOUT',
    purchase: 'ACHAT',
    sale: 'VENTE',
    accounts: 'COMPTES',
    delta: 'RECAP DELTA',
    duplicates: 'DOUBLONS',
    sales: 'Ventes',
    purchases: 'Achats',
    delivered: 'Livrés',
    salesAttr: 'Ventes Attr.',
    purchasesAttr: 'Achats Attr.',
    specialAttr: 'Attr. Spéciale',
    pending: 'En attente',
    cancelled: 'Annulés',
    tickets: 'billets',
    transactions: 'transactions',
    linkedSales: 'Ventes liées',
    linkedPurchases: 'Achats liés',
    inbox: 'Boîte Mail',
    refresh: 'Actualiser',
    autoMatch: 'Matcher',
    attribute: 'Attribuer',
    unattribute: 'Désattribuer',
    newTicket: 'Nouveau',
    import: 'Importer',
    export: 'Exporter',
    exportAll: 'Exporter tout',
    exportCurrentView: 'Exporter la vue active',
    massDeliver: 'Livrer en masse',
    massEdit: 'Modifier en masse',
    unattributeAll: 'Désattribuer tout',
    deleteAll: 'Supprimer tout',
    massDelete: 'Suppression en masse',
    autoAttribution: 'Attribution automatique',
    manualAttribution: 'Attribution manuelle',
    specialAttribution: 'Attribution spéciale',
    unattributeAllTickets: 'Désattribuer tout',
    search: 'Rechercher...',
    allStatuses: 'Tous les statuts',
    attributed: 'Attribué',
    notAttributed: 'Non attribué',
    match: 'MATCH',
    category: 'CATÉGORIE',
    emailAccount: 'E-MAIL DU COMPTE',
    pwAccount: 'PW DU COMPTE',
    source: 'SOURCE',
    saleRef: 'RÉF. VENTE',
    purchaseRef: 'RÉF. ACHAT',
    clientName: 'NOM CLIENT',
    clientEmail: 'MAIL CLIENT',
    sendProof: 'PREUVE ENVOI',
    location: 'LIEU',
    city: 'VILLE',
    country: 'PAYS',
    date: 'DATE',
    qty: 'QTY',
    price: 'PRIX',
    note: 'NOTE',
    status: 'STATUT',
    seat: 'PLACE',
    row: 'RANG',
    block: 'BLOCK',
    session: 'SESSION',
    stand: 'TRIBUNE',
    access: 'ACCÈS',
    staircase: 'ESCALIER',
    soldOn: 'VENDU LE',
    platform: 'PLATEFORME',
    proof: 'PREUVE',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    duplicatesDetected: 'doublon(s) détecté(s) — seront mis à jour',
    projectWarning: 'Attention : incohérence de projet',
    importSummary: "Résumé de l'import",
    newTickets: 'Nouveaux billets',
    updates: 'Mises à jour',
    ticketsToCreate: 'Tickets à créer',
    mappedColumns: 'Colonnes mappées',
    lines: 'Lignes',
    type: 'Type',
    continueImport: 'Continuer → Import',
    checking: 'Vérification...',
    autoSync: 'Sync Auto Emails',
    rocketposter: 'Rocketposter',
    deleteProject: 'Supprimer ce projet',
    noTickets: 'Aucun ticket trouvé',
    selected: 'sélectionné(s)',
    available: 'disponible(s)',
    inAccounts: 'dans',
    accountsLabel: 'compte(s)',
    select: 'Sélectionner',
  },
  en: {
    _label: 'English',
    _flag: '🇬🇧',
    clickToChangeProject: 'Click on the logo to switch',
    chooseProject: 'Choose a project:',
    loading: 'Loading...',
    noProject: 'No project',
    active: 'active',
    versionHistory: 'Version history',
    downloadLogs: 'Download debug logs',
    serverHealth: 'Server health',
    logout: 'Logout',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    all: 'ALL',
    purchase: 'PURCHASE',
    sale: 'SALE',
    accounts: 'ACCOUNTS',
    delta: 'RECAP DELTA',
    duplicates: 'DUPLICATES',
    sales: 'Sales',
    purchases: 'Purchases',
    delivered: 'Delivered',
    salesAttr: 'Sales Attr.',
    purchasesAttr: 'Purchases Attr.',
    specialAttr: 'Special Attr.',
    pending: 'On Hold',
    cancelled: 'Cancelled',
    tickets: 'tickets',
    transactions: 'transactions',
    linkedSales: 'Linked sales',
    linkedPurchases: 'Linked purchases',
    inbox: 'Inbox',
    refresh: 'Refresh',
    autoMatch: 'Matcher',
    attribute: 'Attribute',
    unattribute: 'Unattribute',
    newTicket: 'New',
    import: 'Import',
    export: 'Export',
    exportAll: 'Export all',
    exportCurrentView: 'Export current view',
    massDeliver: 'Mass deliver',
    massEdit: 'Mass edit',
    unattributeAll: 'Unattribute all',
    deleteAll: 'Delete all',
    massDelete: 'Mass delete',
    autoAttribution: 'Auto attribution',
    manualAttribution: 'Manual attribution',
    specialAttribution: 'Special attribution',
    unattributeAllTickets: 'Unattribute all',
    search: 'Search...',
    allStatuses: 'All statuses',
    attributed: 'Attributed',
    notAttributed: 'Not attributed',
    match: 'MATCH',
    category: 'CATEGORY',
    emailAccount: 'ACCOUNT EMAIL',
    pwAccount: 'ACCOUNT PW',
    source: 'SOURCE',
    saleRef: 'SALE REF.',
    purchaseRef: 'PURCHASE REF.',
    clientName: 'CLIENT NAME',
    clientEmail: 'CLIENT EMAIL',
    sendProof: 'SEND PROOF',
    location: 'VENUE',
    city: 'CITY',
    country: 'COUNTRY',
    date: 'DATE',
    qty: 'QTY',
    price: 'PRICE',
    note: 'NOTE',
    status: 'STATUS',
    seat: 'SEAT',
    row: 'ROW',
    block: 'BLOCK',
    session: 'SESSION',
    stand: 'STAND',
    access: 'ACCESS',
    staircase: 'STAIRCASE',
    soldOn: 'SOLD ON',
    platform: 'PLATFORM',
    proof: 'PROOF',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    duplicatesDetected: 'duplicate(s) detected — will be updated',
    projectWarning: 'Warning: project mismatch',
    importSummary: 'Import summary',
    newTickets: 'New tickets',
    updates: 'Updates',
    ticketsToCreate: 'Tickets to create',
    mappedColumns: 'Mapped columns',
    lines: 'Lines',
    type: 'Type',
    continueImport: 'Continue → Import',
    checking: 'Checking...',
    autoSync: 'Auto Sync Emails',
    rocketposter: 'Rocketposter',
    deleteProject: 'Delete this project',
    noTickets: 'No tickets found',
    selected: 'selected',
    available: 'available',
    inAccounts: 'in',
    accountsLabel: 'account(s)',
    select: 'Select',
  },
  de: {
    _label: 'Deutsch',
    _flag: '🇩🇪',
    clickToChangeProject: 'Logo klicken zum Wechseln',
    chooseProject: 'Projekt wählen:',
    loading: 'Laden...',
    noProject: 'Kein Projekt',
    active: 'aktiv',
    versionHistory: 'Versionsverlauf',
    downloadLogs: 'Debug-Logs herunterladen',
    logout: 'Abmelden',
    lightMode: 'Heller Modus',
    darkMode: 'Dunkler Modus',
    all: 'ALLES',
    purchase: 'KAUF',
    sale: 'VERKAUF',
    accounts: 'KONTEN',
    delta: 'RECAP DELTA',
    duplicates: 'DUPLIKATE',
    sales: 'Verkäufe',
    purchases: 'Käufe',
    delivered: 'Geliefert',
    salesAttr: 'Verk. Zugeord.',
    purchasesAttr: 'Käufe Zugeord.',
    specialAttr: 'Spezial Zuord.',
    pending: 'Ausstehend',
    cancelled: 'Storniert',
    tickets: 'Tickets',
    transactions: 'Transaktionen',
    linkedSales: 'Verknüpfte Verkäufe',
    linkedPurchases: 'Verknüpfte Käufe',
    inbox: 'Posteingang',
    refresh: 'Aktualisieren',
    autoMatch: 'Matcher',
    attribute: 'Zuordnen',
    unattribute: 'Zuordnung aufheben',
    newTicket: 'Neu',
    import: 'Importieren',
    export: 'Exportieren',
    exportAll: 'Alles exportieren',
    exportCurrentView: 'Aktuelle Ansicht exportieren',
    massDeliver: 'Massenlieferung',
    massEdit: 'Massenbearbeitung',
    unattributeAll: 'Alle Zuordnungen aufheben',
    deleteAll: 'Alle löschen',
    massDelete: 'Massenlöschung',
    autoAttribution: 'Auto-Zuordnung',
    manualAttribution: 'Manuelle Zuordnung',
    specialAttribution: 'Spezial-Zuordnung',
    unattributeAllTickets: 'Alle Zuordnungen aufheben',
    search: 'Suchen...',
    allStatuses: 'Alle Status',
    attributed: 'Zugeordnet',
    notAttributed: 'Nicht zugeordnet',
    match: 'MATCH',
    category: 'KATEGORIE',
    emailAccount: 'KONTO-EMAIL',
    pwAccount: 'KONTO-PW',
    source: 'QUELLE',
    saleRef: 'VERK. REF.',
    purchaseRef: 'KAUF REF.',
    clientName: 'KUNDENNAME',
    clientEmail: 'KUNDEN-EMAIL',
    sendProof: 'SENDENACHWEIS',
    location: 'ORT',
    city: 'STADT',
    country: 'LAND',
    date: 'DATUM',
    qty: 'MENGE',
    price: 'PREIS',
    note: 'NOTIZ',
    status: 'STATUS',
    seat: 'PLATZ',
    row: 'REIHE',
    block: 'BLOCK',
    session: 'SITZUNG',
    stand: 'TRIBÜNE',
    access: 'ZUGANG',
    staircase: 'TREPPE',
    soldOn: 'VERKAUFT AM',
    platform: 'PLATTFORM',
    proof: 'NACHWEIS',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    close: 'Schließen',
    duplicatesDetected: 'Duplikat(e) erkannt — werden aktualisiert',
    projectWarning: 'Achtung: Projektkonflikt',
    importSummary: 'Import-Zusammenfassung',
    newTickets: 'Neue Tickets',
    updates: 'Aktualisierungen',
    ticketsToCreate: 'Tickets zu erstellen',
    mappedColumns: 'Zugeordnete Spalten',
    lines: 'Zeilen',
    type: 'Typ',
    continueImport: 'Weiter → Import',
    checking: 'Überprüfung...',
    autoSync: 'Auto-Sync E-Mails',
    rocketposter: 'Rocketposter',
    deleteProject: 'Projekt löschen',
    noTickets: 'Keine Tickets gefunden',
    selected: 'ausgewählt',
    available: 'verfügbar',
    inAccounts: 'in',
    accountsLabel: 'Konto(n)',
    select: 'Auswählen',
  },
  es: {
    _label: 'Español',
    _flag: '🇪🇸',
    clickToChangeProject: 'Haz clic en el logo para cambiar',
    chooseProject: 'Elegir un proyecto:',
    loading: 'Cargando...',
    noProject: 'Sin proyecto',
    active: 'activo',
    versionHistory: 'Historial de versiones',
    downloadLogs: 'Descargar logs',
    logout: 'Cerrar sesión',
    lightMode: 'Modo claro',
    darkMode: 'Modo oscuro',
    all: 'TODO',
    purchase: 'COMPRA',
    sale: 'VENTA',
    accounts: 'CUENTAS',
    delta: 'RECAP DELTA',
    duplicates: 'DUPLICADOS',
    sales: 'Ventas',
    purchases: 'Compras',
    delivered: 'Entregados',
    salesAttr: 'Ventas Atr.',
    purchasesAttr: 'Compras Atr.',
    specialAttr: 'Atr. Especial',
    pending: 'Pendiente',
    cancelled: 'Cancelados',
    tickets: 'entradas',
    transactions: 'transacciones',
    linkedSales: 'Ventas vinculadas',
    linkedPurchases: 'Compras vinculadas',
    inbox: 'Correo',
    refresh: 'Actualizar',
    autoMatch: 'Matcher',
    attribute: 'Atribuir',
    unattribute: 'Desatribuir',
    newTicket: 'Nuevo',
    import: 'Importar',
    export: 'Exportar',
    exportAll: 'Exportar todo',
    exportCurrentView: 'Exportar vista actual',
    massDeliver: 'Entrega masiva',
    massEdit: 'Edición masiva',
    unattributeAll: 'Desatribuir todo',
    deleteAll: 'Eliminar todo',
    massDelete: 'Eliminación masiva',
    autoAttribution: 'Atribución automática',
    manualAttribution: 'Atribución manual',
    specialAttribution: 'Atribución especial',
    unattributeAllTickets: 'Desatribuir todo',
    search: 'Buscar...',
    allStatuses: 'Todos los estados',
    attributed: 'Atribuido',
    notAttributed: 'No atribuido',
    match: 'PARTIDO',
    category: 'CATEGORÍA',
    emailAccount: 'EMAIL CUENTA',
    pwAccount: 'PW CUENTA',
    source: 'FUENTE',
    saleRef: 'REF. VENTA',
    purchaseRef: 'REF. COMPRA',
    clientName: 'NOMBRE CLIENTE',
    clientEmail: 'EMAIL CLIENTE',
    sendProof: 'PRUEBA ENVÍO',
    location: 'LUGAR',
    city: 'CIUDAD',
    country: 'PAÍS',
    date: 'FECHA',
    qty: 'CANT.',
    price: 'PRECIO',
    note: 'NOTA',
    status: 'ESTADO',
    seat: 'ASIENTO',
    row: 'FILA',
    block: 'BLOQUE',
    session: 'SESIÓN',
    stand: 'TRIBUNA',
    access: 'ACCESO',
    staircase: 'ESCALERA',
    soldOn: 'VENDIDO EL',
    platform: 'PLATAFORMA',
    proof: 'PRUEBA',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    duplicatesDetected: 'duplicado(s) detectado(s) — serán actualizados',
    projectWarning: 'Atención: conflicto de proyecto',
    importSummary: 'Resumen de importación',
    newTickets: 'Nuevas entradas',
    updates: 'Actualizaciones',
    ticketsToCreate: 'Entradas a crear',
    mappedColumns: 'Columnas mapeadas',
    lines: 'Líneas',
    type: 'Tipo',
    continueImport: 'Continuar → Importar',
    checking: 'Verificando...',
    autoSync: 'Sync Auto Emails',
    rocketposter: 'Rocketposter',
    deleteProject: 'Eliminar proyecto',
    noTickets: 'No se encontraron entradas',
    selected: 'seleccionado(s)',
    available: 'disponible(s)',
    inAccounts: 'en',
    accountsLabel: 'cuenta(s)',
    select: 'Seleccionar',
  },
  vi: {
    _label: 'Tiếng Việt',
    _flag: '🇻🇳',
    clickToChangeProject: 'Nhấn vào logo để chuyển đổi',
    chooseProject: 'Chọn dự án:',
    loading: 'Đang tải...',
    noProject: 'Không có dự án',
    active: 'đang hoạt động',
    versionHistory: 'Lịch sử phiên bản',
    downloadLogs: 'Tải nhật ký',
    logout: 'Đăng xuất',
    lightMode: 'Chế độ sáng',
    darkMode: 'Chế độ tối',
    all: 'TẤT CẢ',
    purchase: 'MUA',
    sale: 'BÁN',
    accounts: 'TÀI KHOẢN',
    delta: 'TỔNG HỢP DELTA',
    duplicates: 'TRÙNG LẶP',
    sales: 'Bán hàng',
    purchases: 'Mua hàng',
    delivered: 'Đã giao',
    salesAttr: 'Bán đã gán',
    purchasesAttr: 'Mua đã gán',
    specialAttr: 'Gán đặc biệt',
    pending: 'Đang chờ',
    cancelled: 'Đã hủy',
    tickets: 'vé',
    transactions: 'giao dịch',
    linkedSales: 'Bán hàng liên kết',
    linkedPurchases: 'Mua hàng liên kết',
    inbox: 'Hộp thư',
    refresh: 'Làm mới',
    autoMatch: 'Ghép tự động',
    attribute: 'Gán',
    unattribute: 'Hủy gán',
    newTicket: 'Mới',
    import: 'Nhập',
    export: 'Xuất',
    exportAll: 'Xuất tất cả',
    exportCurrentView: 'Xuất chế độ xem hiện tại',
    massDeliver: 'Giao hàng loạt',
    massEdit: 'Sửa hàng loạt',
    unattributeAll: 'Hủy gán tất cả',
    deleteAll: 'Xóa tất cả',
    massDelete: 'Xóa hàng loạt',
    autoAttribution: 'Gán tự động',
    manualAttribution: 'Gán thủ công',
    specialAttribution: 'Gán đặc biệt',
    unattributeAllTickets: 'Hủy gán tất cả',
    search: 'Tìm kiếm...',
    allStatuses: 'Tất cả trạng thái',
    attributed: 'Đã gán',
    notAttributed: 'Chưa gán',
    match: 'TRẬN ĐẤU',
    category: 'HẠNG',
    emailAccount: 'EMAIL TÀI KHOẢN',
    pwAccount: 'MK TÀI KHOẢN',
    source: 'NGUỒN',
    saleRef: 'MÃ BÁN',
    purchaseRef: 'MÃ MUA',
    clientName: 'TÊN KHÁCH',
    clientEmail: 'EMAIL KHÁCH',
    sendProof: 'BẰNG CHỨNG GỬI',
    location: 'ĐỊA ĐIỂM',
    city: 'THÀNH PHỐ',
    country: 'QUỐC GIA',
    date: 'NGÀY',
    qty: 'SL',
    price: 'GIÁ',
    note: 'GHI CHÚ',
    status: 'TRẠNG THÁI',
    seat: 'GHẾ',
    row: 'HÀNG',
    block: 'KHU',
    session: 'PHIÊN',
    stand: 'KHÁN ĐÀI',
    access: 'LỐI VÀO',
    staircase: 'CẦU THANG',
    soldOn: 'NGÀY BÁN',
    platform: 'NỀN TẢNG',
    proof: 'BẰNG CHỨNG',
    edit: 'Sửa',
    delete: 'Xóa',
    save: 'Lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    close: 'Đóng',
    duplicatesDetected: 'bản trùng lặp được phát hiện — sẽ được cập nhật',
    projectWarning: 'Cảnh báo: không khớp dự án',
    importSummary: 'Tóm tắt nhập',
    newTickets: 'Vé mới',
    updates: 'Cập nhật',
    ticketsToCreate: 'Vé cần tạo',
    mappedColumns: 'Cột đã ánh xạ',
    lines: 'Dòng',
    type: 'Loại',
    continueImport: 'Tiếp tục → Nhập',
    checking: 'Đang kiểm tra...',
    autoSync: 'Tự động đồng bộ Email',
    rocketposter: 'Rocketposter',
    deleteProject: 'Xóa dự án',
    noTickets: 'Không tìm thấy vé',
    selected: 'đã chọn',
    available: 'có sẵn',
    inAccounts: 'trong',
    accountsLabel: 'tài khoản',
    select: 'Chọn',
  },
};

export default translations;
